export default '/build/4b70b571.svg'